import ApplicationAdapter from "./application";

export default class RemoteHandsRequestAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.baseUri()}/remotehands/create`;
  }
}
